$(document).ajaxStart(() => {
    $("#imgHeader").attr("style", "animation: blink 2s ease-in infinite");
    $("#imgHeaderwide").attr("style", "animation: blink 2s ease-in infinite");
});
$(document).ajaxStop(() => {
    $("#imgHeader").css("animation", "");
    $("#imgHeaderwide").css("animation", "");
});
$(window).on("unload", () => {
    return false;
});
jQuery.fn.rotate = function (degrees) {
    $(this).css({
        "-webkit-transform": "rotate(" + degrees + "deg)",
        "-moz-transform": "rotate(" + degrees + "deg)",
        "-ms-transform": "rotate(" + degrees + "deg)",
        transform: "rotate(" + degrees + "deg)",
    });
    return $(this);
};
stringEndsWithPolyfill();
stringStartsWithPolyfill();

//# sourceMappingURL=onPageLoad.js.map
